import React from 'react';

import { testAttribute } from 'src/utils/Serenity';
import { LocaleLink } from '../ContentLink/LocaleLink';
import { createLinkTracker, workaroundRef } from './Util';

export const TrackedLink = React.forwardRef<HTMLAnchorElement, React.AllHTMLAttributes<HTMLAnchorElement> & { 'data-test'?: string }>(
  ({ href, title, onClick, ...props }, ref) => {
    const dataTest = title ? testAttribute(title) : 'contact-policy';
    if (href && href.indexOf('~') === 0) {
      return <LocaleLink innerRef={node => workaroundRef(node, ref)} to={href.replace('~', '')} data-test={dataTest} {...{ title, onClick, ...props }} />;
    }

    return <a ref={ref} onClick={createLinkTracker(onClick)} {...{ href, title, ...props }} />;
  }
);
